import { Message, MessageService } from 'primeng/api';
import { Subject } from 'rxjs/index';
import { Injectable } from '@angular/core';

/**
 * Encargado de las notificaciones locales, gestión de las funcionalidades y diversas funciones de navegación.
 */
@Injectable({ providedIn: 'root' })
export class MessageAlertService {
  /**
   * Mensaje por defecto(Información)
   * @type {Message}
   */
  msgs: any;
  /**
   * Mensaje por defecto(Adición)
   * @type {Message}
   */
  msgAdd: Message = {
    severity: 'success',
    summary: 'Éxito',
    detail: 'Registro agregado correctamente.',
    key: 'examen',
  };
  /**
   * Mensaje por defecto(Actualización)
   * @type {Message}
   */
  msgUpdate: Message = {
    severity: 'success',
    summary: 'Éxito',
    detail: 'Registro actualizado correctamente.',
    key: 'examen',
  };
  /**
   * Mensaje por defecto(Error)
   * @type {Message}
   */
  msgError: Message = {
    severity: 'error',
    summary: 'Error',
    detail: 'Error al guardar / Intente nuevamente.',
    key: 'examen',
  };

  /**
   * Observable para los mensajes
   * @type {Subject<Message>}
   */
  subject = new Subject<Message[]>();
  /**
   * Observable string streams
   */
  getMessage$ = this.subject.asObservable();

  timeOut: any;

  /**
   * Construye la instancia
   */
  constructor(private messageService: MessageService) {}

  /**
   * asignar mensaje para notificar al usuario
   * @param {number} type
   * @param {Message} msgCustom
   * @param {boolean} hide
   */
  setMessage(type: number, msgCustom: Message = null, hide = true) {
    this.messageService.clear();
    clearTimeout(this.timeOut);
    switch (type) {
      case 1:
        this.msgs = this.msgAdd;
        break;
      case 2:
        this.msgs = this.msgUpdate;
        break;
      case 3:
        this.msgs = this.msgError;
        break;
      default:
        this.msgs = msgCustom;
        if (!this.msgs.key) {
          this.msgs.key = 'examen';
        }
        break;
    }
    setTimeout(() => {
      this.messageService.add(this.msgs);
    }, 100);
    this.timeOut = setTimeout(() => {
      this.messageService.clear();
    }, 10000);
  }
}
